module.exports = __webpack_public_path__ + "11fd79bcf7943677aa0a7217a8e19470.ttf";